'use client'

import BookDemoModal from '@/components/RevampedLanding/BookDemo'
import HeroSection from '@/components/RevampedLanding/HeroSection'
import usePageType from '@/hooks/useLandingPageType'
import { eventTracker } from '@/lib/events/cjrEventTracker'
import { getLocalStorageValue } from '@/utils/common'
import { CjrWidgetsId } from '@/utils/enums'
import { isFromApp } from '@/utils/utils'
import createWidget from '@/widgets/create-widget'
import { PhotoIcon } from '@heroicons/react/24/solid'
import { usePathname, useRouter } from 'next/navigation'
import { JSX, useEffect, useState } from 'react'
import ICJRLandingHeroSection, { CJRLandingHeroSectionProps, HeroSectionDefaultValues } from './schema'

export function CJRLandingHeroSection(props: CJRLandingHeroSectionProps) {
  const router = useRouter()

  const pathname = usePathname()
  const { heroSection, isOtplessEnabled, appRedirectionScreen, shouldTriggerTruecaller, goalSection } = props

  const [isBookDemoModalOpen, setIsBookDemoModalOpen] = useState(false)

  const { currentPageType, fullPath } = usePageType()

  const handleOpenBookDemoModal = ({ clickFrom }: { clickFrom?: string }) => {
    eventTracker.bookADemoClick({
      clickFrom: clickFrom as 'sticky' | 'hero_section' | 'cohorts_section' | 'product_features_section',
      came_from: currentPageType,
      page_link: fullPath as string,
    })
    setIsBookDemoModalOpen(true)
  }

  useEffect(() => {
    const _window = typeof window !== 'undefined' ? window : null

    if (typeof window !== 'undefined' && window.location.origin.includes('curiousjr.com')) {
      if (_window && _window?.PWWebSDK) {
        if (_window.PWWebSDK?.accessToken) {
          router.replace(`${window.location.origin}/v2/home`)
        }
      }
      if (typeof window !== 'undefined' && getLocalStorageValue('TOKEN')) {
        router.replace(`${window.location.origin}/v2/home`)
      }
    }
  }, [])

  return (
    <>
      <HeroSection handleOpenBookDemoModal={handleOpenBookDemoModal} heroSectionData={heroSection} />
      {isBookDemoModalOpen ? (
        <BookDemoModal
          activeState='select_goal'
          open={isBookDemoModalOpen}
          onClose={() => setIsBookDemoModalOpen(false)}
          goals={goalSection?.goals}
          isOtplessEnabled={isOtplessEnabled}
          appRedirectionScreen={appRedirectionScreen}
          shouldTriggerTruecaller={shouldTriggerTruecaller || false}
          pageSource={isFromApp() ? 'APP' : 'LANDING'}
        />
      ) : null}
    </>
  )
}

export default createWidget<CJRLandingHeroSectionProps>({
  formType: ICJRLandingHeroSection,
  render(props): JSX.Element {
    return <CJRLandingHeroSection {...props} />
  },
  id: CjrWidgetsId.LANDING_PAGE_HERO_SECTION,
  name: 'Hero Section',
  icon: <PhotoIcon className='w-10 h-10' />,
  defaultProps: HeroSectionDefaultValues,
})
